import { render, staticRenderFns } from "./newUserModal.vue?vue&type=template&id=129f3a9e&scoped=true&"
import script from "./newUserModal.vue?vue&type=script&lang=js&"
export * from "./newUserModal.vue?vue&type=script&lang=js&"
import style0 from "./newUserModal.vue?vue&type=style&index=0&id=129f3a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f3a9e",
  null
  
)

export default component.exports